import { loadRemote } from '@module-federation/runtime';
import { lazy } from 'react';

import { RemoteModule } from 'types/federation';

export function getRemoteModule(name: string): React.LazyExoticComponent<React.ComponentType<any>>  {
  return lazy(async () => {
    const module = await loadRemote<RemoteModule>(`${name}/App`);

    if (!module?.default) {
      throw new Error(`Module ${name} does not have a default export`);
    }
    
    return module;
  });
} 
